import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const disconnectPeerThunk = createAppAsyncThunk<
  { sixId: string; peerId: string; disconnectedCount: number },
  { sixId: string; peerId: string }
>(
  'connection/disconnectPeer',
  async({ sixId, peerId }, { extra: { pocServices }, rejectWithValue }) => {
    try {
      const libp2pNode = pocServices.p2pStackManagerService.getLibp2pNode(sixId);
      if (libp2pNode === null) {
        throw new Error(`No LibP2P node found for six '${sixId}'`);
      }

      const peerConnections = libp2pNode
        .getConnections()
        .filter((connection) => connection.remotePeer.toString() === peerId);

      await Promise.all(
        peerConnections.map(async(connection) => {
          await connection.close();
        })
      );

      return {
        sixId,
        peerId,
        disconnectedCount: peerConnections.length,
      };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue({ message });
    }
  }
);
